import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es7.string.trim-right";
import "core-js/modules/es6.function.name";
import * as tslib_1 from "tslib"; // tslint:disable:max-classes-per-file

import { getCurrentHub, Hub } from '@sentry/hub';
import { isInstanceOf, logger } from '@sentry/utils';
import { Span as SpanClass } from './span';
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */

var SpanRecorder =
/** @class */
function () {
  function SpanRecorder(maxlen) {
    if (maxlen === void 0) {
      maxlen = 1000;
    }

    this.spans = [];
    this._maxlen = maxlen;
  }
  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */


  SpanRecorder.prototype.add = function (span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  };

  return SpanRecorder;
}();

export { SpanRecorder };
/** JSDoc */

var Transaction =
/** @class */
function (_super) {
  tslib_1.__extends(Transaction, _super);
  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */


  function Transaction(transactionContext, hub) {
    var _this = _super.call(this, transactionContext) || this;
    /**
     * The reference to the current hub.
     */


    _this._hub = getCurrentHub();

    if (isInstanceOf(hub, Hub)) {
      _this._hub = hub;
    }

    if (transactionContext.name) {
      _this.name = transactionContext.name;
    }

    _this._trimEnd = transactionContext.trimEnd;
    return _this;
  }
  /**
   * JSDoc
   */


  Transaction.prototype.setName = function (name) {
    this.name = name;
  };
  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */


  Transaction.prototype.initSpanRecorder = function (maxlen) {
    if (maxlen === void 0) {
      maxlen = 1000;
    }

    if (!this.spanRecorder) {
      this.spanRecorder = new SpanRecorder(maxlen);
    }

    this.spanRecorder.add(this);
  };
  /**
   * @inheritDoc
   */


  Transaction.prototype.finish = function (endTimestamp) {
    var _this = this; // This transaction is already finished, so we should not flush it again.


    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    _super.prototype.finish.call(this, endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      logger.warn('Discarding transaction because it was not chosen to be sampled.');
      return undefined;
    }

    var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) {
      return s !== _this && s.endTimestamp;
    }) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce(function (prev, current) {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }

        return prev;
      }).endTimestamp;
    }

    return this._hub.captureEvent({
      contexts: {
        trace: this.getTraceContext()
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction'
    });
  };

  return Transaction;
}(SpanClass);

export { Transaction };